module.exports = __webpack_public_path__ + "static/img/boy-waving--small.d0e8bed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/school-hall/boy-waving--small.svg
// module id = 175
// module chunks = 2